// extracted by mini-css-extract-plugin
module.exports = {"Description":"Description_Description__aaxhP","descriptionText":"Description_descriptionText__-btUa","readMore":"Description_readMore__STYg6"};